import styled from 'styled-components';
import media from '../../styles/config/mediaQueries';

const StyledContainer = styled.div`
  ${media.mobile`
    padding: 25px 0;
  `}
`;

const StyledBoardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -12px;
`;

export { StyledContainer, StyledBoardsContainer };
